import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'Quanto tempo leva para meu site ficar pronto?',
      answer: 'O tempo de desenvolvimento varia conforme a complexidade do projeto. Landing pages ficam prontas em 48-72 horas. Sites institucionais levam de 5 a 7 dias úteis. Trabalhamos com agilidade sem comprometer a qualidade.'
    },
    {
      question: 'O investimento realmente vale a pena?',
      answer: 'Absolutamente. Um site profissional é seu vendedor trabalhando 24/7. Nossos clientes reportam aumento médio de 300% em solicitações de orçamento. O retorno sobre investimento geralmente acontece no primeiro mês.'
    },
    {
      question: 'Preciso ter conhecimento técnico para gerenciar o site?',
      answer: 'Não! Desenvolvemos sites intuitivos com painel administrativo simples. Além disso, oferecemos treinamento completo e suporte técnico. Você foca no seu negócio, nós cuidamos da parte técnica.'
    },
    {
      question: 'O que está incluído no pacote de manutenção?',
      answer: 'Hospedagem premium em servidores rápidos, backup automático diário, atualizações de segurança, monitoramento 24/7, suporte técnico prioritário e pequenas alterações de conteúdo. Tudo por R$ 69,90/mês.'
    },
    {
      question: 'Posso fazer alterações no site depois de pronto?',
      answer: 'Sim! Você pode fazer alterações de conteúdo pelo painel administrativo. Para mudanças de design ou funcionalidades, oferecemos pacotes de atualização com preços acessíveis.'
    },
    {
      question: 'O site vai aparecer no Google?',
      answer: 'Sim! Todos os nossos sites são desenvolvidos com SEO avançado integrado. Isso inclui otimização de velocidade, estruturação correta de conteúdo, meta tags e integração com Google Search Console.'
    },
    {
      question: 'E se eu não ficar satisfeito com o resultado?',
      answer: 'Oferecemos garantia de 100% de satisfação. Fazemos revisões até você ficar completamente feliz com o resultado. Seu sucesso é nossa prioridade número 1.'
    },
    {
      question: 'Por que seus preços são mais altos que outros?',
      answer: 'Qualidade tem preço. Não somos os mais baratos, somos os melhores. Enquanto outros entregam templates genéricos, criamos soluções exclusivas que realmente convertem. O investimento se paga rapidamente com os resultados.'
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" style={{
      padding: '120px 40px',
      background: 'linear-gradient(180deg, #0a0a0a 0%, #000000 100%)'
    }}>
      <div style={{ maxWidth: '900px', margin: '0 auto' }}>
        <div className="fade-in" style={{ textAlign: 'center', marginBottom: '80px' }}>
          <h2 className="section-title">
            Perguntas <span className="gold-gradient">Frequentes</span>
          </h2>
          <p className="section-subtitle">
            Tire suas dúvidas sobre nossos serviços e processos.
            Não encontrou sua resposta? Entre em contato conosco.
          </p>
        </div>

        <div style={{ marginBottom: '60px' }}>
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="fade-in"
              style={{
                marginBottom: '20px',
                background: 'linear-gradient(145deg, rgba(212, 175, 55, 0.05) 0%, transparent 100%)',
                border: '1px solid rgba(212, 175, 55, 0.2)',
                borderRadius: '12px',
                overflow: 'hidden',
                transition: 'border-color 0.3s ease',
                transitionDelay: `${idx * 0.1}s`
              }}
            >
              <button
                onClick={() => toggleFAQ(idx)}
                style={{
                  width: '100%',
                  padding: '25px 30px',
                  background: 'none',
                  border: 'none',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  textAlign: 'left',
                  transition: 'background 0.3s ease'
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(212, 175, 55, 0.05)'}
                onMouseLeave={(e) => e.currentTarget.style.background = 'none'}
              >
                <span style={{
                  fontFamily: 'Montserrat, sans-serif',
                  fontSize: '18px',
                  fontWeight: '600',
                  color: '#FFFFFF',
                  flex: 1
                }}>
                  {faq.question}
                </span>
                <ChevronDown
                  size={24}
                  color="#D4AF37"
                  style={{
                    transition: 'transform 0.3s ease',
                    transform: openIndex === idx ? 'rotate(180deg)' : 'rotate(0deg)'
                  }}
                />
              </button>
              <div
                style={{
                  maxHeight: openIndex === idx ? '500px' : '0',
                  overflow: 'hidden',
                  transition: 'max-height 0.3s ease, padding 0.3s ease',
                  padding: openIndex === idx ? '0 30px 25px 30px' : '0 30px'
                }}
              >
                <p style={{
                  fontFamily: 'Montserrat, sans-serif',
                  fontSize: '15px',
                  fontWeight: '300',
                  color: '#CCCCCC',
                  lineHeight: '1.8',
                  paddingTop: '10px',
                  borderTop: '1px solid rgba(212, 175, 55, 0.2)'
                }}>
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Contact CTA */}
        <div className="fade-in" style={{
          textAlign: 'center',
          padding: '50px',
          background: 'linear-gradient(135deg, rgba(212, 175, 55, 0.1) 0%, transparent 100%)',
          border: '1px solid rgba(212, 175, 55, 0.3)',
          borderRadius: '12px',
          transitionDelay: '0.8s'
        }}>
          <h3 style={{
            fontFamily: 'Playfair Display, serif',
            fontSize: '28px',
            fontWeight: '700',
            marginBottom: '15px',
            color: '#FFFFFF'
          }}>
            Ainda tem dúvidas?
          </h3>
          <p style={{
            fontFamily: 'Montserrat, sans-serif',
            fontSize: '16px',
            fontWeight: '300',
            color: '#CCCCCC',
            marginBottom: '30px'
          }}>
            Fale conosco pelo WhatsApp e tire todas as suas dúvidas.
            Estamos aqui para ajudar!
          </p>
          <button
            onClick={() => window.open('https://wa.me/5562995664918?text=Olá! Tenho algumas dúvidas sobre os serviços.', '_blank')}
            className="btn-secondary"
          >
            FALAR NO WHATSAPP
          </button>
        </div>
      </div>
    </section>
  );
};

export default FAQ;